import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { showErrorToast, showSuccessToast } from '../../../utils/toastHelper';
import ResetPasswordForm from '../components/ResetPasswordForm';
import { useLoading } from '../../../contexts/LoadingContext';
import { resetPassword } from '../services/authService';
import { useTranslation } from 'react-i18next';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const { t } = useTranslation('login');
  const { loading, setLoading } = useLoading();
  const navigate = useNavigate();

  const token = searchParams.get('token');
  const email = searchParams.get('email');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    // setErrors({});

    // Validate passwords match
    if (password !== confirmPassword) {
      // setErrors({ confirmPassword: ['.'] });
      showErrorToast(t('PASSWORDSDONOTMATCH'));
      setLoading(false);
      return;
    }

    // Validate password strength (minimum 8 characters)
    if (password.length < 8) {
      // setErrors({ password: ['.'] });
      showErrorToast(t('PASSWORDMUSTBEATLEAST8CHARACTERS'));

      setLoading(false);
      return;
    }

    const response = await resetPassword({
      email,
      token,
      password,
      password_confirmation: confirmPassword,
    });

    if (response.success) {
      showSuccessToast(response.message || 'Success');

      // Redirect to login after 3 seconds
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    }

    setLoading(false);
  };

  return (
    <div>
      <section id="login">
        <div className="left">
          <span>
            <img src="images/s&flogo.svg" alt="Logo" />
          </span>
        </div>
        <div className="right">
          <ResetPasswordForm
            password={password}
            setPassword={setPassword}
            confirmPassword={confirmPassword}
            setConfirmPassword={setConfirmPassword}
            handleSubmit={handleSubmit}
            loading={loading}
            email={email}
          />
        </div>
      </section>
    </div>
  );
};

export default ResetPasswordPage;
